export const Dots = ( {data, x, y, color }) => (
  data.map((d, i) => {
    // if it doesn't get called, the coloring is absolutely weird
    // previously it was called due to console.log, and after removing it,
    // the bug started to appear!
    return (
        d.fatty_acids.map(fa => {
          return (
            <circle
              className='active'
                cx={x(d.label) + x.bandwidth()/2}
                cy={y(fa.label)}
                r={5*Math.sqrt(fa.count)}
                fill={color(fa.label)}
                stroke={'black'}
            />
          )
        })
      )
  }
  )
);
